import { render, staticRenderFns } from "./StudentsWalletTransactionsReportFilter.vue?vue&type=template&id=3ffa27ca&"
import script from "./StudentsWalletTransactionsReportFilter.vue?vue&type=script&lang=js&"
export * from "./StudentsWalletTransactionsReportFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports